import { WorkflowVariable } from '@refly/openapi-schema';

// 工作流配置类型定义
export interface WorkflowConfigTask {
  id: string;
  title: string;
  prompt: string;
  toolsets: string[];
  dependentTasks?: string[];
}

export interface WorkflowConfigVariable {
  variableId: string;
  variableType: string;
  name: string;
  description: string;
  required: boolean;
}

export interface WorkflowConfig {
  name: string;
  arguments: {
    title: string;
    tasks: WorkflowConfigTask[];
    variables: WorkflowConfigVariable[];
  };
}

// 解析工作流配置
export const parseWorkflowConfig = (config: WorkflowConfig): {
  title: string;
  tasks: WorkflowConfigTask[];
  variables: WorkflowVariable[];
} => {
  const { title, tasks, variables } = config.arguments;

  // 转换变量为前端使用的格式
  const convertedVariables: WorkflowVariable[] = variables.map(variable => {
    let variableType: 'string' | 'option' | 'resource';
    
    // 映射变量类型
    switch (variable.variableType) {
      case 'string':
      case 'text':
        variableType = 'string';
        break;
      case 'option':
        variableType = 'option';
        break;
      case 'resource':
        variableType = 'resource';
        break;
      default:
        variableType = 'string';
    }

    return {
      variableId: variable.variableId,
      name: variable.name,
      description: variable.description,
      variableType,
      required: variable.required,
      value: [],
      options: [],
      resourceTypes: [],
      isSingle: true,
    };
  });

  return {
    title,
    tasks,
    variables: convertedVariables,
  };
};

// 验证工作流配置
export const validateWorkflowConfig = (config: any): boolean => {
  if (!config || typeof config !== 'object') {
    return false;
  }

  if (!config.arguments || typeof config.arguments !== 'object') {
    return false;
  }

  if (!config.arguments.title || typeof config.arguments.title !== 'string') {
    return false;
  }

  if (!Array.isArray(config.arguments.tasks)) {
    return false;
  }

  if (!Array.isArray(config.arguments.variables)) {
    return false;
  }

  // 验证任务
  for (const task of config.arguments.tasks) {
    if (!task.id || typeof task.id !== 'string') {
      return false;
    }
    if (!task.title || typeof task.title !== 'string') {
      return false;
    }
    if (!task.prompt || typeof task.prompt !== 'string') {
      return false;
    }
    if (!Array.isArray(task.toolsets)) {
      return false;
    }
  }

  // 验证变量
  for (const variable of config.arguments.variables) {
    if (!variable.variableId || typeof variable.variableId !== 'string') {
      return false;
    }
    if (!variable.variableType || typeof variable.variableType !== 'string') {
      return false;
    }
    if (!variable.name || typeof variable.name !== 'string') {
      return false;
    }
    if (!variable.description || typeof variable.description !== 'string') {
      return false;
    }
    if (typeof variable.required !== 'boolean') {
      return false;
    }
  }

  return true;
};
